const destinations = [
    {
        id: 1,
        name: 'Ponagar Tower',
        images: [
            'https://media.istockphoto.com/id/532042524/vi/anh/po-nagar-cham-towers-nha-trang-vietnam.jpg?s=612x612&w=0&k=20&c=syS7DCZA9FQZ_-zycnlXdbmaSTny3xVSoG-3Z7TkS6g=',
            'https://media.istockphoto.com/id/1469190041/vi/anh/drone-nh%C3%ACn-th%E1%BA%A5y-th%C3%A1p-ponagar-trong-ho%C3%A0ng-h%C3%B4n.jpg?s=612x612&w=0&k=20&c=exqVIQCzmk4mgh5dU-X7XbYFLl6oE7sPqcaVznuO6rE=',
            'https://media.istockphoto.com/id/1198172600/vi/anh/%C4%91%E1%BB%81n-c%E1%BB%95-po-nagar-t%C3%B4n-gi%C3%A1o-v%C3%A0-ki%E1%BA%BFn-tr%C3%BAc-hindu.jpg?s=612x612&w=0&k=20&c=KgBmnZ_Zh1jID56QIfdCHoS-8NAC4njzDMEkhdQKfss=',
        ],
        description: 'Nha Trang Tower is often associated with sea tourism activities, but Nha Trang Ponagar Tower – a famous historical site is still chosen by many visitors for their journey to explore this land. This is an incredibly unique architectural work of ancient Champ people worth experiencing. ',
    },
    {
        id: 2,
        name: 'Ngoc Hoi Straw Mat Craft Village',
        images: [
            'https://cdn.vntrip.vn/cam-nang/wp-content/uploads/2016/01/kham-pha-lang-det-chieu-truyen-thong-my-trach-o-nha-trang.jpg',
            'https://langnghenhatrangxua.com/wp-content/uploads/2024/04/lang-nghe-det-chieu-o-viet-nam-1.jpg',
            'https://i.ex-cdn.com/nongnghiep.vn/files/bao_in/2022/01/09/dat-lung-chieu-coi-mo-mang-lang-oi-1135_20220109_720-113849.jpeg',
        ],
        description: 'If you are a lover of traditional culture and want to explore the cultural beauty of Vietnam, then the Ngoc Hoi Straw Mat Craft Village in Nha Trang is a must-see destination. This is one of the most famous traditional trade villages in Khanh Hoa Province. ',
    },
    {
        id: 3,
        name: 'Lu Cam Pocerlain Craft Village',
        images: [
            'https://statics.vntrip.vn/data-v2/data-guide/img_content/1462846582_lang-lu-cam-3.jpg',
            'https://gomsuhcm.com/wp-content/uploads/2023/08/Dac-diem-cua-gom-su-Lu-Cam-tai-Nha-Trang.jpg',
            'https://baoxaydung.com.vn/stores/news_dataimages/baoxaydung/072008/02/13/dsvh_2.7.0820100729160751.gif?gidzl=lQVSAYAyE2ApkDujAA8-9BY-sIW_y6fsfEoAUpZpQtgcweuWFQHh8V6-YNeyzsuahUcFB6EfAjSu9xmuAW',
        ],
        description: 'Nha Trang Lu Cam Village is a place famous for its long and distinctive pocerlain traditions. With the unique features of traditional ceramics, the Lu Cam Village not only attracts visitors but is also an ideal destination for those who love making ceramics. ',
    },
    {
        id: 4,
        name: 'Xom Bong Fishing Village',
        images: [
            'https://www.gotadi.com/tour/wp-content/uploads/2020/01/15364685291293_4-1140x530.jpg',
            'https://i2.ex-cdn.com/crystalbay.com/files/content/2023/12/13/lang-chai-5-1724.jpg',
            'https://static.vinwonders.com/2022/03/lang-chai-nha-trang-1-1.jpg',
        ],
        description: 'The fishing village where the inhabitants of Nha Trang lived for many years with the fishing of seafood is a unique and interesting destination, for visitors to experience fishing and aquaculture which are characteristics of the coastal people. '
    },
    {
        id: 5,
        name: 'The Nha Trang Institute of Oceanology',
        images: [
            'https://bestour.com.vn/uploads/co-g-ben-trong-dai-duong-thu-nho-vien-hai-duong-hoc-nha-trang-1.jpg',
            'https://statics.vinpearl.com/vien-hai-duong-hoc-nha-trang-2_1633840784.jpeg',
            'https://owa.bestprice.vn/images/articles/uploads/moi-nhat-kinh-nghiem-di-vien-hai-duong-hoc-nha-trang-tu-a-z-5f3251f94ce81.jpg',
        ],
        description: 'The Nha Trang Institute of Oceanology is home to the largest study of marine life in Southeast Asia. Tourists who are passionate about exploring the mystery of the ocean and want to learn about the life of marine creatures should not miss this fascinating location. '
    },
    {
        id: 6,
        name: 'FBT Happy Farm',
        images: [
            'https://res.cloudinary.com/drvydie5q/image/upload/v1720633792/Dynamic%20folders/etct1bfkgk3pknoug1fm.jpg',
            'https://res.cloudinary.com/drvydie5q/image/upload/v1720633848/Dynamic%20folders/ozibpz6wx1hf2b4gylj6.jpg',
            'https://res.cloudinary.com/drvydie5q/image/upload/v1720633088/Dynamic%20folders/fltvdps32tdmh2gsicyf.jpg',
        ],
        description: 'Bringing the tradition of Vietnamese - Agriculture into the hands of everyone. Visitors will experience the feeling of being a farmer and engaging in real farming activities. '
    },

];

export default destinations